import { object, number, string } from 'yup';
import { TFunction } from 'i18next';

export function makeClientConfirmationSchema(t: TFunction) {
  return object().shape({
    a: number().required(t('form.required')),
    b: number().required(t('form.required')),
    c: string().required(t('form.required')),
    d: string(),
    once: number(),
    monthly: number(),
  });
}
